import { KalturaAssetMetaOrTagGroupBy, KalturaAssetType } from '@kaltura-ott/ott-client-types/api/types';
import { KalturaAssetCount } from '@kaltura-ott/ott-client-types/api/types/KalturaAssetCount';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { getAssetCount } from './asset';
import { KuXDms } from './dms';

export interface Season {
  episodesCount: number;
  seasonNumber: string;
}

export function getSeasonsList(
  seriesId: string,
  assetType: KalturaAssetType | string = KalturaAssetType.epg,
): Observable<Season[]> {
  const groupByValue = 'SeasonNumber';
  const filterCatchup = `(or start_date>'-${KuXDms.playableCatchupBuffer}' Popular='1')`;
  const kSql =
    assetType == KalturaAssetType.epg
      ? `(and SeriesID = '${seriesId}' asset_type = '${assetType}' ${filterCatchup})`
      : `(and SeriesID = '${seriesId}' asset_type = '${assetType}')`;
  const groupBy = [new KalturaAssetMetaOrTagGroupBy({ value: groupByValue })];
  return getAssetCount({ kSql, groupBy }).pipe(
    map((data) => {
      const seasons = data?.subs.find((el) => el.field === groupByValue);
      return (
        seasons?.objects.map(
          (el: KalturaAssetCount): Season => ({ episodesCount: el.count, seasonNumber: el.value }),
        ) || []
      ).sort(({ seasonNumber: seasonNumber1 }, { seasonNumber: seasonNumber2 }) =>
        Number(seasonNumber1) > Number(seasonNumber2) ? 1 : -1,
      );
    }),
    catchError((error) => {
      console.warn(error);
      return of([]);
    }),
  );
}

export const getChannelLogoList = (seriesId: string): Observable<number[]> => {
  const groupByValue = 'LINEAR_MEDIA_ID';

  const kSql = `(and SeriesID = '${seriesId}')`;
  const groupBy = [new KalturaAssetMetaOrTagGroupBy({ value: groupByValue })];

  return getAssetCount({ kSql, groupBy }).pipe(
    map((data) => {
      const linears = data?.subs.find((el) => el.field === groupByValue);
      return linears?.objects
        .map((linear) => (linear.value ? Number(linear.value) : undefined))
        .filter(Boolean) as number[];
    }),
    catchError((error) => {
      console.warn(error);
      return of([] as number[]);
    }),
  );
};
